<template>
  <AppConfirmDialog
    :model-value="state.open"
    :title="state.title"
    :message="state.message"
    :confirm-text="state.confirmText"
    :cancel-text="state.cancelText"
    :alert-only="state.alertOnly"
    @confirm="onConfirm"
    @cancel="onCancel"
  />
</template>

<script setup lang="ts">
import AppConfirmDialog from '@/components/common/AppConfirmDialog.vue'
import { resolveAppConfirm, useAppConfirmState } from '@/composables/useAppConfirm'

const state = useAppConfirmState()

const onConfirm = () => resolveAppConfirm(true)
const onCancel = () => resolveAppConfirm(false)
</script>
